import ExcelJS from "exceljs";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";

export const ExportEmployee = ({ employeeData }) => {
    const exportToExcel = async () => {

        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Zone");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Employee Details Generated on: ${formattedDate}, ${formattedTime}`;

        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 11);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add "Employee Details" header
        worksheet.addRow(["", "", "Employee Details", ""]);
        worksheet.mergeCells(2, 2, 2, 11);
        worksheet.getCell(2, 2).value = "Employee Details";
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Employee ID",
            "Employee Name",
            "Operation",
            "Designation",
            "Zone",
            "Circle",
            "Transfer Station",
            "Gender",
            "Contact No",
            "Shift",
            "Status",
        ]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
            if (colNumber >= 1 && colNumber <= 12) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" }, // Background color
                    bgColor: { argb: "FFFFFFFF" } // Text color
                };
            }
        });

        // Add data rows
        employeeData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.employeeId || "N/A",
                item.employeeName || "N/A",
                item.operationName || "N/A",
                item.designationName || "N/A",
                item.zoneName || "N/A",
                item.circleName || "N/A",
                item.transferStationName || "N/A",
                item.gender || "N/A",
                item.contactNo || "N/A",
                item.shiftName || "N/A",
                item.isActive ? "Active" : "InActive",
            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                cell.alignment = { horizontal: "center" };
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 30 },
            { width: 30 },
            { width: 30 },
            { width: 20 },
            { width: 20 },
            { width: 30 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
            { width: 15 },
        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Employee.xlsx";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };
    const exportToPDF = () => {
        const doc = new jsPDF("landscape", "mm", "a4"); // Landscape orientation
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Employee Details Generated on: ${formattedDate} ${formattedTime}`;
        doc.setFont("helvetica", "bold");  // Set font to Helvetica and style to bold
        doc.setFontSize(16);
        doc.text("Employee Details", 14, 20);  // Title text at (x, y) coordinates
        doc.setFontSize(12);
        doc.text(downloadDateTime, 14, 30);
        autoTable(doc, {
            startY: 35,
            head: [
                [
                    "S.No",
                    "Employee ID",
                    "Employee Name",
                    "Operation",
                    "Designation",
                    "Zone",
                    "Circle",
                    "Transfer Station",
                    "Gender",
                    "Contact No",
                    "Shift",
                    "Status",
                ],
            ],
            body: employeeData.map((item, index) => [
                index + 1,
                item.employeeId || "N/A",
                item.employeeName || "N/A",
                item.operationName || "N/A",
                item.designationName || "N/A",
                item.zoneName || "N/A",
                item.circleName || "N/A",
                item.transferStationName || "N/A",
                item.gender || "N/A",
                item.contactNo || "N/A",
                item.shiftName || "N/A",
                item.isActive ? "Active" : "InActive",
            ]),
            headStyles: { fillColor: "red" },
            styles: {
                fontSize: 7, // Reduced font size for better fitting
                halign: "center",
            },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 20 },
                2: { cellWidth: 30 },
                3: { cellWidth: 25 },
                4: { cellWidth: 25 },
                5: { cellWidth: 25 },
                6: { cellWidth: 25 },
                7: { cellWidth: 40 },
                8: { cellWidth: 15 },
                9: { cellWidth: 20 },
                10: { cellWidth: 15 },
                11: { cellWidth: 15 },
            },
            margin: { top: 20 },
            didParseCell: (data) => {
                if (data.row.raw) {
                    // Reduce padding for compact display
                    data.cell.styles.cellPadding = 2;
                }
            },
        });
        doc.save("EmployeeDetails.pdf");
    };
    return (
        <>
            <button
                className="button-container"
                onClick={exportToExcel}
            >
                <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                Excel
            </button>
            <button
                className="button-container"
                onClick={exportToPDF}
            >
                <i className="fa-solid fa-file-pdf me-1 icon-container"></i>
                PDF
            </button>
        </>
    )
}